import { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { MSG } from 'commons/constants';
import { message } from 'antd';

interface EMailTemplateCodeprops {
  params: MailTemplateCodeListReqDto;
}

const useEMailTemplateCode = ({params}: EMailTemplateCodeprops) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [codeList, setCodeList] = useState<UserCodeListDto[]>();

  const {  } = useQuery(
    [endpoints.refcode.mail.codelistN, params],
    () =>
      fetcher.refcode.getEMailCodeList(params),
    {
      enabled: !!params.mail_type && params.mail_type !== '',
      onSuccess: (res: UserCodeListResDto) => {
        switch (res.code) {
          case 200:
            setCodeList(res.result?.list);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );


  return { codeList  };
};

export default useEMailTemplateCode;
